module.exports = __webpack_public_path__ + "img/back_closure_length.912c38a4.png";